<template>
  <div class="dash">
    <!-- ============================================
         ROW 1 — HERO BANNER (full width)
         ============================================ -->
    <div class="dash__hero">
      <div class="dash__hero-noise"></div>
      <div class="dash__hero-gradient"></div>

      <!-- Floating coin pile image — bottom-right atmosphere -->
      <img
        src="/resources/upgrade/assets/Untitled project-Layer 2 15.14.28-Photoroom.png"
        alt=""
        class="dash__hero-coins"
      />

      <div class="dash__hero-inner">
        <div class="dash__hero-text">
          <span class="dash__hero-tag">
            <i class="mdi mdi-shield-check"></i>
            DASHBOARD
          </span>
          <p class="dash__hero-greet">Welcome back,</p>
          <h2 class="dash__hero-name">{{ $store.getters.currentUser.username }}</h2>

          <div class="dash__hero-pills">
            <div class="dash__hero-pill">
              <span class="dash__hero-pill-label">Wallet</span>
              <span class="dash__hero-pill-val">${{ $store.getters.currentUser.vault.amount }}</span>
            </div>
            <div class="dash__hero-pill">
              <span class="dash__hero-pill-label">Max Cap</span>
              <span class="dash__hero-pill-val">${{ $store.getters.currentUser.account_max_cap }}</span>
            </div>
            <div class="dash__hero-pill dash__hero-pill--accent">
              <span class="dash__hero-pill-label">Progress</span>
              <span class="dash__hero-pill-val">{{ $store.getters.currentUser.account_progress }}%</span>
            </div>
          </div>

          <div class="dash__hero-actions">
            <router-link to="/plans" class="dash__btn dash__btn--gold">
              <i class="mdi mdi-cube-outline"></i> Packages
            </router-link>
            <router-link to="/balance" class="dash__btn dash__btn--glass">
              <i class="mdi mdi-wallet"></i> Withdraw
            </router-link>
          </div>
        </div>

        <!-- Single bitcoin coin — hero right -->
        <div class="dash__hero-coin-wrap">
          <img
            src="/resources/upgrade/assets/Gemini_Generated_Image_yfbjidyfbjidyfbj-Photoroom.png"
            alt="Bitcoin"
            class="dash__hero-coin"
          />
        </div>
      </div>
    </div>

    <!-- ============================================
         ROW 2 — TICKER STRIP
         ============================================ -->
    <div class="dash__ticker">
      <div class="tradingview-widget-container">
        <div class="tradingview-widget-container__widget" id="tradingview-chart"></div>
      </div>
    </div>

    <!-- ============================================
         ROW 3 — BENTO GRID (main content)
         ============================================ -->
    <div class="dash__bento">

      <!-- LEFT COLUMN — Wallet + Rank + Progress stacked -->
      <div class="dash__col-left">
        <wallet></wallet>

        <div class="dash__rank-card" v-if="$store.getters.currentUser.rank != 'regular'">
          <div class="dash__rank-glow"></div>
          <div class="dash__rank-body">
            <img :src="$store.getters.currentUser.rank_icon" alt="" class="dash__rank-img" />
            <h4 class="dash__rank-name">{{ $store.getters.currentUser.rank }}</h4>
          </div>
        </div>

        <account-progress></account-progress>
      </div>

      <!-- CENTER COLUMN — Stats + AI banner -->
      <div class="dash__col-center">

        <!-- Top row: SwapLeg + Binary to Pay side-by-side -->
        <div class="dash__pair">
          <div class="dash__pair-item">
            <swap-leg></swap-leg>
          </div>
          <div class="dash__pair-item">
            <div class="dash__stat-card">
              <div class="dash__stat-accent"></div>
              <div class="dash__stat-head">
                <i class="mdi mdi-source-branch"></i>
                <span>Binary to Pay</span>
              </div>
              <div class="dash__stat-num">
                {{ $store.getters.currentUser.binary_to_pay || 0 }}<small>%</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Triple stat row -->
        <div class="dash__triple">
          <div class="dash__stat-card dash__stat-card--cyan">
            <div class="dash__stat-accent dash__stat-accent--cyan"></div>
            <div class="dash__stat-head">
              <i class="mdi mdi-speedometer"></i>
              <span>Direct Line Pts</span>
            </div>
            <div class="dash__stat-num">
              {{ $store.getters.currentUser.point.direct_line_points || 0 }}
            </div>
          </div>

          <div class="dash__stat-card dash__stat-card--green">
            <div class="dash__stat-accent dash__stat-accent--green"></div>
            <div class="dash__stat-head">
              <i class="mdi mdi-shield"></i>
              <span>Strong Branch</span>
            </div>
            <div class="dash__stat-num">
              {{ $store.getters.currentUser.point.binary_strong_points || 0 }}
            </div>
          </div>

          <div class="dash__stat-card dash__stat-card--magenta">
            <div class="dash__stat-accent dash__stat-accent--magenta"></div>
            <div class="dash__stat-head">
              <i class="mdi mdi-alert-circle"></i>
              <span>Weak Branch</span>
            </div>
            <div class="dash__stat-num">
              {{ $store.getters.currentUser.point.binary_weak_points || 0 }}
            </div>
          </div>
        </div>

        <!-- AI Engine Banner -->
        <div class="dash__ai">
          <div class="dash__ai-accent"></div>
          <div class="dash__ai-orb dash__ai-orb--1"></div>
          <div class="dash__ai-orb dash__ai-orb--2"></div>

          <div class="dash__ai-inner">
            <div class="dash__ai-text">
              <div class="dash__ai-badge">
                <i class="mdi mdi-chip"></i>
                <span>AI-POWERED</span>
              </div>
              <h3 class="dash__ai-title">Intelligent Trading Engine</h3>
              <p class="dash__ai-desc">
                Advanced AI algorithms analyze market patterns,
                optimize investment strategies and maximize returns in real-time across
                blockchain and real estate markets.
              </p>
              <div class="dash__ai-features">
                <div class="dash__ai-feat">
                  <i class="mdi mdi-trending-up"></i>
                  <span>Smart Analytics</span>
                </div>
                <div class="dash__ai-feat">
                  <i class="mdi mdi-shield"></i>
                  <span>Risk Optimization</span>
                </div>
                <div class="dash__ai-feat">
                  <i class="mdi mdi-flash"></i>
                  <span>Real-Time Processing</span>
                </div>
              </div>
            </div>
            <div class="dash__ai-visual">
              <img
                src="/resources/upgrade/assets/Gemini_Generated_Image_80xd9580xd9580xd-Photoroom.png"
                alt="AI Engine"
                class="dash__ai-img"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================================
         ROW 4 — MARKET WIDGETS (full-width grid)
         ============================================ -->
    <div class="dash__markets">
      <div class="dash__market-card">
        <div class="dash__market-accent"></div>
        <div class="dash__market-head">
          <i class="mdi mdi-chart-line"></i>
          <h4>Crypto Heatmap</h4>
        </div>
        <div class="dash__market-body">
          <div id="crypto-heatmap" style="height: 450px"></div>
        </div>
      </div>

      <div class="dash__market-card">
        <div class="dash__market-accent"></div>
        <div class="dash__market-head">
          <i class="mdi mdi-view-dashboard"></i>
          <h4>Market Overview</h4>
        </div>
        <div class="dash__market-body">
          <div id="crypto-screener" style="height: 550px"></div>
        </div>
      </div>
    </div>

    <promo-modal></promo-modal>
  </div>
</template>

<style scoped>
/* ==========================================
   DASHBOARD SHELL
   ========================================== */
.dash {
  padding: 8px 0 40px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* ==========================================
   HERO BANNER
   ========================================== */
.dash__hero {
  position: relative;
  background: linear-gradient(160deg, #1e1e1e 0%, #282824 50%, #222220 100%);
  border: 1px solid rgba(176, 154, 78, 0.12);
  border-radius: 22px;
  overflow: hidden;
  min-height: 260px;
  isolation: isolate;
}

/* Noise texture overlay */
.dash__hero-noise {
  position: absolute;
  inset: 0;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.03'/%3E%3C/svg%3E");
  background-size: 200px;
  opacity: 0.5;
  z-index: 1;
  pointer-events: none;
}

/* Ambient gradient wash */
.dash__hero-gradient {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 60% 80% at 15% 50%, rgba(176, 154, 78, 0.07) 0%, transparent 70%),
    radial-gradient(ellipse 40% 60% at 85% 30%, rgba(123, 191, 181, 0.04) 0%, transparent 60%);
  z-index: 1;
  pointer-events: none;
}

/* Coin pile — atmospheric bottom-right */
.dash__hero-coins {
  position: absolute;
  right: -40px;
  bottom: -60px;
  width: 520px;
  opacity: 0.12;
  pointer-events: none;
  z-index: 1;
  filter: grayscale(0.3) contrast(1.1);
}

/* Content layer */
.dash__hero-inner {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 36px 40px;
  gap: 30px;
}

.dash__hero-text {
  flex: 1;
  min-width: 0;
}

/* Tag badge */
.dash__hero-tag {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 14px;
  border-radius: 100px;
  background: rgba(176, 154, 78, 0.08);
  border: 1px solid rgba(176, 154, 78, 0.15);
  font-family: 'Orbitron', sans-serif;
  font-size: 0.5rem;
  color: #B09A4E;
  letter-spacing: 0.18em;
  margin-bottom: 16px;
}

.dash__hero-tag i {
  font-size: 0.75rem;
}

.dash__hero-greet {
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.9rem;
  color: #9A998F;
  margin: 0 0 2px;
  letter-spacing: 0.03em;
}

.dash__hero-name {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 1.65rem !important;
  color: #E0DFD8 !important;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  margin: 0 0 22px !important;
  line-height: 1.2;
  background: linear-gradient(135deg, #E0DFD8 30%, #B09A4E 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* Stat pills */
.dash__hero-pills {
  display: flex;
  gap: 10px;
  margin-bottom: 24px;
  flex-wrap: wrap;
}

.dash__hero-pill {
  display: flex;
  flex-direction: column;
  gap: 3px;
  padding: 10px 18px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 14px;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  min-width: 100px;
  transition: all 0.3s ease;
}

.dash__hero-pill:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(176, 154, 78, 0.2);
  transform: translateY(-2px);
}

.dash__hero-pill--accent .dash__hero-pill-val {
  color: #CDBA6E;
}

.dash__hero-pill-label {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.5rem;
  color: #6B6A62;
  text-transform: uppercase;
  letter-spacing: 0.12em;
}

.dash__hero-pill-val {
  font-family: 'Orbitron', sans-serif;
  font-size: 1.05rem;
  font-weight: 700;
  color: #E0DFD8;
}

/* Action buttons */
.dash__hero-actions {
  display: flex;
  gap: 10px;
}

.dash__btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 22px;
  border-radius: 12px;
  font-family: 'Orbitron', sans-serif;
  font-size: 0.6rem;
  font-weight: 600;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-decoration: none !important;
  cursor: pointer;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.dash__btn i { font-size: 1rem; }

.dash__btn--gold {
  background: linear-gradient(135deg, #B09A4E, #8C7A3B) !important;
  color: #1a1a1a !important;
  border: 1px solid #B09A4E;
  box-shadow: 0 4px 20px rgba(176, 154, 78, 0.2);
}

.dash__btn--gold:hover {
  box-shadow: 0 8px 30px rgba(176, 154, 78, 0.35);
  transform: translateY(-2px);
}

.dash__btn--glass {
  background: rgba(255, 255, 255, 0.04) !important;
  color: #C2C1B8 !important;
  border: 1px solid rgba(194, 193, 184, 0.12);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.dash__btn--glass:hover {
  background: rgba(176, 154, 78, 0.08) !important;
  border-color: rgba(176, 154, 78, 0.25);
  color: #B09A4E !important;
}

/* Hero coin — right side */
.dash__hero-coin-wrap {
  flex-shrink: 0;
  position: relative;
}

.dash__hero-coin {
  width: 220px;
  height: auto;
  filter:
    drop-shadow(0 15px 40px rgba(0, 0, 0, 0.5))
    drop-shadow(0 0 60px rgba(176, 154, 78, 0.08));
  animation: coinSpin 8s ease-in-out infinite;
}

@keyframes coinSpin {
  0%, 100% { transform: translateY(0) rotateY(0deg); }
  25% { transform: translateY(-6px) rotateY(5deg); }
  50% { transform: translateY(-10px) rotateY(0deg); }
  75% { transform: translateY(-6px) rotateY(-5deg); }
}

/* ==========================================
   TICKER STRIP
   ========================================== */
.dash__ticker {
  background: rgba(37, 37, 37, 0.6);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 14px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* ==========================================
   BENTO GRID
   ========================================== */
.dash__bento {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 20px;
  align-items: start;
}

.dash__col-left {
  display: flex;
  flex-direction: column;
  gap: 0;
}

.dash__col-center {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

/* Pair row (SwapLeg + Binary) */
.dash__pair {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
}

.dash__pair-item {
  min-width: 0;
}

/* Triple stat row */
.dash__triple {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

/* ==========================================
   STAT CARDS
   ========================================== */
.dash__stat-card {
  background: linear-gradient(145deg, #232323, #2b2b2b);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 16px;
  padding: 22px;
  position: relative;
  overflow: hidden;
  transition: all 0.35s cubic-bezier(0.4, 0, 0.2, 1);
}

.dash__stat-card:hover {
  border-color: rgba(176, 154, 78, 0.18);
  transform: translateY(-3px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
}

/* Top accent line */
.dash__stat-accent {
  position: absolute;
  top: 0;
  left: 20%;
  right: 20%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #B09A4E, transparent);
  border-radius: 0 0 4px 4px;
}

.dash__stat-accent--cyan {
  background: linear-gradient(90deg, transparent, #7BBFB5, transparent);
}

.dash__stat-accent--green {
  background: linear-gradient(90deg, transparent, #7BC88F, transparent);
}

.dash__stat-accent--magenta {
  background: linear-gradient(90deg, transparent, #C46B8F, transparent);
}

.dash__stat-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 14px;
}

.dash__stat-head i {
  font-size: 1.1rem;
  color: #B09A4E;
}

.dash__stat-card--cyan .dash__stat-head i { color: #7BBFB5; }
.dash__stat-card--green .dash__stat-head i { color: #7BC88F; }
.dash__stat-card--magenta .dash__stat-head i { color: #C46B8F; }

.dash__stat-head span {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.6rem;
  color: #9A998F;
  text-transform: uppercase;
  letter-spacing: 0.08em;
}

.dash__stat-num {
  font-family: 'Orbitron', sans-serif;
  font-size: 2rem;
  font-weight: 700;
  color: #E0DFD8;
  line-height: 1;
}

.dash__stat-num small {
  font-size: 0.9rem;
  color: #9A998F;
  margin-left: 2px;
  font-weight: 400;
}

/* ==========================================
   RANK CARD
   ========================================== */
.dash__rank-card {
  background: linear-gradient(145deg, #232323, #2b2b2b);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 20px;
  text-align: center;
  transition: all 0.35s ease;
}

.dash__rank-card:hover {
  border-color: rgba(196, 107, 143, 0.2);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

.dash__rank-glow {
  height: 2px;
  background: linear-gradient(90deg, transparent, #C46B8F, transparent);
}

.dash__rank-body {
  padding: 22px 20px;
}

.dash__rank-img {
  max-width: 9rem;
  filter: drop-shadow(0 0 20px rgba(196, 107, 143, 0.15));
}

.dash__rank-name {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.8rem !important;
  color: #C46B8F !important;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  margin-top: 12px !important;
}

/* ==========================================
   AI ENGINE BANNER
   ========================================== */
.dash__ai {
  position: relative;
  background: linear-gradient(155deg, #222220 0%, #282824 50%, #232323 100%);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 18px;
  overflow: hidden;
}

.dash__ai-accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, transparent 10%, #7BBFB5 40%, #B09A4E 60%, transparent 90%);
}

.dash__ai-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(50px);
  pointer-events: none;
}

.dash__ai-orb--1 {
  width: 200px;
  height: 200px;
  background: rgba(123, 191, 181, 0.05);
  top: -50px;
  left: 10%;
  animation: orbDrift 10s ease-in-out infinite;
}

.dash__ai-orb--2 {
  width: 150px;
  height: 150px;
  background: rgba(176, 154, 78, 0.04);
  bottom: -30px;
  right: 25%;
  animation: orbDrift 8s ease-in-out infinite reverse;
}

@keyframes orbDrift {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(10px, -15px) scale(1.05); }
}

.dash__ai-inner {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 30px 32px;
  gap: 24px;
}

.dash__ai-text {
  flex: 1;
  min-width: 0;
}

.dash__ai-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 12px;
  border-radius: 100px;
  background: rgba(123, 191, 181, 0.07);
  border: 1px solid rgba(123, 191, 181, 0.15);
  margin-bottom: 14px;
}

.dash__ai-badge i {
  color: #7BBFB5;
  font-size: 0.8rem;
}

.dash__ai-badge span {
  font-family: 'Orbitron', sans-serif;
  font-size: 0.5rem;
  color: #7BBFB5;
  letter-spacing: 0.15em;
  font-weight: 600;
}

.dash__ai-title {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 1.05rem !important;
  color: #E0DFD8 !important;
  letter-spacing: 0.06em;
  margin: 0 0 10px !important;
}

.dash__ai-desc {
  color: #9A998F;
  font-size: 0.85rem;
  line-height: 1.7;
  margin: 0 0 16px;
  max-width: 480px;
}

.dash__ai-features {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.dash__ai-feat {
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: 'Rajdhani', sans-serif;
  font-size: 0.78rem;
  font-weight: 600;
  color: #C2C1B8;
}

.dash__ai-feat i {
  color: #B09A4E;
  font-size: 0.95rem;
}

.dash__ai-visual {
  flex-shrink: 0;
}

.dash__ai-img {
  width: 170px;
  height: auto;
  filter: drop-shadow(0 8px 30px rgba(0, 0, 0, 0.4));
  animation: orbDrift 7s ease-in-out infinite;
}

/* ==========================================
   MARKET WIDGETS
   ========================================== */
.dash__markets {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.dash__market-card {
  background: linear-gradient(145deg, #232323, #2a2a2a);
  border: 1px solid rgba(194, 193, 184, 0.08);
  border-radius: 18px;
  overflow: hidden;
  position: relative;
}

.dash__market-accent {
  position: absolute;
  top: 0;
  left: 15%;
  right: 15%;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(176, 154, 78, 0.25), transparent);
}

.dash__market-head {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 18px 22px;
  border-bottom: 1px solid rgba(194, 193, 184, 0.06);
}

.dash__market-head i {
  color: #B09A4E;
  font-size: 1.15rem;
}

.dash__market-head h4 {
  font-family: 'Orbitron', sans-serif !important;
  font-size: 0.75rem !important;
  color: #E0DFD8 !important;
  letter-spacing: 0.08em;
  margin: 0 !important;
  text-transform: uppercase;
}

.dash__market-body {
  padding: 0;
}

/* ==========================================
   RESPONSIVE
   ========================================== */
@media (max-width: 1199px) {
  .dash__bento {
    grid-template-columns: 280px 1fr;
  }
}

@media (max-width: 991px) {
  .dash__bento {
    grid-template-columns: 1fr;
  }

  .dash__col-left {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px;
  }

  .dash__hero-inner {
    flex-direction: column;
    text-align: center;
    padding: 28px 24px;
  }

  .dash__hero-pills {
    justify-content: center;
  }

  .dash__hero-actions {
    justify-content: center;
  }

  .dash__hero-coin {
    width: 160px;
  }

  .dash__markets {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767px) {
  .dash__col-left {
    grid-template-columns: 1fr;
  }

  .dash__pair {
    grid-template-columns: 1fr;
  }

  .dash__triple {
    grid-template-columns: 1fr;
  }

  .dash__hero-coin-wrap {
    display: none;
  }

  .dash__hero-coins {
    opacity: 0.06;
  }

  .dash__hero-inner {
    padding: 24px 20px;
  }

  .dash__ai-inner {
    flex-direction: column;
    text-align: center;
  }

  .dash__ai-features {
    justify-content: center;
  }

  .dash__ai-img {
    width: 120px;
  }
}

@media (max-width: 480px) {
  .dash__hero-pills {
    flex-direction: column;
    align-items: center;
  }

  .dash__hero-pill {
    width: 100%;
    text-align: center;
  }

  .dash__hero-actions {
    flex-direction: column;
    align-items: center;
  }

  .dash__btn {
    width: 100%;
    justify-content: center;
  }
}
</style>

<script>
import SwapLeg from "@/components/SwapLeg";
import AccountProgress from "@/components/AccountProgress";
import PromoModal from "@/components/PromoModal";
import Wallet from "@/components/Wallet";

export default {
  name: "Home",

  components: { SwapLeg, AccountProgress, PromoModal, Wallet },
  mounted() {
    this.loadTickerTape();
    this.loadHeatmap();
    this.loadScreener();
  },
  methods: {
    loadTickerTape() {
      var config = {
        symbols: [
          { description: "Bitcoin", proName: "BINANCE:BTCUSDT" },
          { description: "Ethereum", proName: "BINANCE:ETHUSDT" },
          { description: "BNB", proName: "BINANCE:BNBUSDT" },
          { description: "XRP", proName: "BINANCE:XRPUSDT" },
          { description: "Solana", proName: "BINANCE:SOLUSDT" },
          { description: "Cardano", proName: "BINANCE:ADAUSDT" },
          { description: "Dogecoin", proName: "BINANCE:DOGEUSDT" },
        ],
        colorTheme: "dark",
        isTransparent: true,
        locale: "en",
      };
      var node = document.createElement("script");
      node.innerText = JSON.stringify(config);
      node.async = true;
      node.src = "https://s3.tradingview.com/external-embedding/embed-widget-tickers.js";
      document.getElementById("tradingview-chart").appendChild(node);
    },
    loadHeatmap() {
      var config = {
        dataSource: "Crypto",
        blockSize: "market_cap_calc",
        blockColor: "change",
        locale: "en",
        symbolUrl: "",
        colorTheme: "dark",
        hasTopBar: false,
        isDataSetEnabled: false,
        isZoomEnabled: true,
        hasSymbolTooltip: true,
        isMonoSize: false,
        width: "100%",
        height: "100%",
      };
      var node = document.createElement("script");
      node.innerText = JSON.stringify(config);
      node.async = true;
      node.src = "https://s3.tradingview.com/external-embedding/embed-widget-crypto-coins-heatmap.js";
      document.getElementById("crypto-heatmap").appendChild(node);
    },
    loadScreener() {
      var config = {
        width: "100%",
        height: "100%",
        defaultColumn: "overview",
        defaultScreen: "general",
        market: "crypto",
        showToolbar: true,
        colorTheme: "dark",
        locale: "en",
        isTransparent: true,
      };
      var node = document.createElement("script");
      node.innerText = JSON.stringify(config);
      node.async = true;
      node.src = "https://s3.tradingview.com/external-embedding/embed-widget-screener.js";
      document.getElementById("crypto-screener").appendChild(node);
    },
  },
};
</script>
